import { render } from "./InfiniteScrollList.vue?vue&type=template&id=67130429"
import script from "./InfiniteScrollList.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__